import React from 'react';
import { Text, View, Image, Pressable, StyleSheet } from 'react-native';

import OPComponent from '../op_component';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../../constants/styles';

import PlaceHolderText from './placeholder_text';
import ValidatedComponent from './validated_comp';

const ARROW_IMAGE_SOURCE = require('../../../../resources/arrow-down.png');

export default class DropDown extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      requiredError: false,
      validateError: false,
    };
    this._validatedRef = React.createRef();
  }

  validate() {
    return this._validatedRef.current?.validate();
  }

  render() {
    let {
      required = false,
      label,
      value,
      disabled,
      editable,
      imageSource,
      containerStyle,
      buttonStyle,
      buttonValueTextStyle,
      buttonValueTextContainerStyle,
      arrowIconStyle,
      placeholder,
      styleType,
    } = this.props;

    const notEditable = !!(disabled || editable === false);

    const dropdownStyle = [styles.dropdownButton, buttonStyle];
    if (disabled) {
      dropdownStyle.push(THEME.inputContainerDisabled);
    } else if (notEditable) {
      dropdownStyle.push(styles.dropdownButtonNotEditable);
    }
    if (styleType === 'roundStyle') dropdownStyle.push(styles.dropdownButtonRound);

    const textStyle = [styles.dropdownButtonValueText, buttonValueTextStyle];
    if (notEditable) textStyle.push(styles.textDisabled);
    if (styleType === 'roundStyle') dropdownStyle.push(styles.dropdownButtonValueTextRound);

    return (
      <ValidatedComponent
        ref={this._validatedRef}
        style={[styles.container, containerStyle]}
        {...this.props}
      >
        <Pressable style={dropdownStyle} disabled={notEditable} onPress={this.props.onPress}>
          <View style={[styles.buttonTextContainer, buttonValueTextContainerStyle]}>
            {!!value ? (
              <Text numberOfLines={1} ellipsizeMode="tail" style={textStyle}>
                {value}
              </Text>
            ) : (
              <PlaceHolderText
                label={placeholder || label}
                editable={!notEditable}
                containerStyle={styles.placeholderTextContainer}
              />
            )}
          </View>
          {!!imageSource ? (
            <Image
              style={[styles.icon, notEditable ? styles.disabledIcon : null]}
              source={imageSource}
              resizeMode="contain"
            />
          ) : notEditable ? null : (
            <Image
              style={[styles.arrowIcon, notEditable ? styles.disabledIcon : null, arrowIconStyle]}
              source={ARROW_IMAGE_SOURCE}
              resizeMode="contain"
            />
          )}
        </Pressable>
      </ValidatedComponent>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
  placeholderTextContainer: {},
  icon: {
    width: 20,
    height: 20,
    tintColor: 'rgb(89,96,110)',
    marginBottom: 10,
  },
  arrowIcon: {
    width: 12,
    height: 12,
    tintColor: 'rgb(89,96,110)',
    marginBottom: 10,
  },
  disabledIcon: {
    tintColor: COLOR.textDisabled,
  },
  dropdownButton: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    borderBottomWidth: 1,
    borderColor: COLOR.text,
    // marginBottom: 10,
    marginTop: 2,
    paddingTop: 10,
    // backgroundColor: 'pink'
  },
  dropdownButtonNotEditable: {
    borderColor: COLOR.textLight,
  },
  dropdownButtonRound: {
    borderColor: 'rgb(170,170,170)',
    borderWidth: 1,
    borderRadius: 20,
    paddingHorizontal: 20,
    height: 40,
  },
  buttonTextContainer: {
    flex: 1,
    paddingBottom: 8,
    justifyContent: 'center',
  },
  dropdownButtonValueText: {
    ...FONT.regular,
    fontSize: 18,
    color: COLOR.text,
  },
  dropdownButtonValueTextRound: {
    color: 'rgb(33,34,41)',
  },
  textDisabled: {
    color: COLOR.textLight,
  },
});
